import ProxyImage from "@/components/ProxyImage";
import React from "react";
import PhoneRegister from "@/components/PhoneRegister";
import ServicesContactLine from "@/components/ServicesContactLine";
import { getIndependentManualRegisterUrl } from "@/services/getWechatLoginUrl";
import { registerBackgroundUrl } from "@/config";
import "./index.less";

interface IndependentManualRegisterProps {}

const IndependentManualRegister: React.FC<IndependentManualRegisterProps> = function (props) {
    return (
        <div className="ec-independent-manual-register-page">
            <div className="background-image">
                <ProxyImage src={registerBackgroundUrl} alt="" />
            </div>

            <div className="main-container">
                <div className="title">
                    <img
                        src="https://img.alicdn.com/imgextra/i3/54458674/O1CN01WmKWyp2DwkBLqbjgu_!!54458674.png"
                        alt=""
                        className="w50 h50"
                    />
                    <span className="ml10">发货易-自由打印版</span>
                </div>

                <div className="tip">适用微商/快递员/线下商家</div>

                <PhoneRegister
                    getWeChatIframeSrc={(mobile) => getIndependentManualRegisterUrl({ mobile, urlPath: "/" })}
                    loginUrl="/login/independentManual"
                />

                <div className="mt20">
                    <ServicesContactLine />
                </div>
            </div>
        </div>
    );
};

export default React.memo(IndependentManualRegister);
